import axios from "axios";
import { Evento } from "../data/portal-data";

export const PORTAL_EVENTOS_URL = `Portal/Eventos`;

export type EventoCreate = Omit<Evento, "id">;
export type EventoUpdate = Evento;

export const portalEventosServices = {
  /** GET /api/Portal/Eventos — todos los eventos (admin) */
  getAll: () => {
    return axios.get<Evento[]>(PORTAL_EVENTOS_URL);
  },

  /** GET /api/Portal/Eventos/vigentes — solo los visibles hoy (portal público) */
  getVigentes: () => {
    return axios.get<Evento[]>(`${PORTAL_EVENTOS_URL}/vigentes`);
  },

  /** GET /api/Portal/Eventos/:id */
  getById: (id: number) => {
    return axios.get<Evento>(`${PORTAL_EVENTOS_URL}/${id}`);
  },

  /** POST /api/Portal/Eventos */
  create: (data: EventoCreate) => {
    return axios.post<Evento>(PORTAL_EVENTOS_URL, data);
  },

  /** PUT /api/Portal/Eventos/:id */
  update: (id: number, data: EventoUpdate) => {
    return axios.put<Evento>(`${PORTAL_EVENTOS_URL}/${id}`, data);
  },

  /** DELETE /api/Portal/Eventos/:id */
  delete: (id: number) => {
    return axios.delete(`${PORTAL_EVENTOS_URL}/${id}`);
  },
};
